import { swiperRegister, Swiper } from "@ml/swiper/swiper";

swiperRegister();
window.addEventListener("DOMContentLoaded", () => {
  // スライド数をチェックして必要な場合は複製する
  const swiperContainer = document.querySelector(
    "swiper-container.swiper-slide-type-1"
  );
  if (swiperContainer) {
    const slides = swiperContainer.querySelectorAll("swiper-slide");
    if (slides.length <= 3) {
      // 2枚の場合は各スライドを複製
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        swiperContainer.appendChild(clone);
      });
    }
  }

  const swiperElement = document.querySelector(".swiper-slide-type-1");

  if (swiperElement) {
    const swiperType1 = Swiper({
      el: "swiper-container.swiper-slide-type-1",
      options: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: true,
        speed: 500,
        loop: true,
        pagination: {
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.8,
          },
        },
        autoplay: {
          delay: 4000,
        },
        pagination: false,
        // effect: 'coverflow',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // ループモードの追加設定
        loopedSlides: 3, // スライドが2枚の場合の設定
        observer: true, // DOMの変更を監視
        observeParents: true, // 親要素の変更も監視
      },
    });

    const swiperTopWrap = document.querySelector(".js-top-swiper");
    if (swiperTopWrap) {
      setTimeout(() => {
        swiperTopWrap.style.opacity = "1";
      }, 50);
    }
  }
});

window.addEventListener("DOMContentLoaded", () => {
  // スライド数をチェックして必要な場合は複製する
  const swiperContainer = document.querySelector(
    "swiper-container.swiper-slide-type-2"
  );
  if (swiperContainer) {
    const slides = swiperContainer.querySelectorAll("swiper-slide");
    if (slides.length <= 3) {
      // 2枚の場合は各スライドを複製
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        swiperContainer.appendChild(clone);
      });
    }
  }

  const swiperElement = document.querySelector(".swiper-slide-type-2");

  if (swiperElement) {
    const swiperType1 = Swiper({
      el: "swiper-container.swiper-slide-type-2",
      options: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: true,
        speed: 500,
        loop: true,
        pagination: {
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.8,
          },
        },
        autoplay: {
          delay: 4000,
        },
        pagination: false,
        // effect: 'coverflow',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // ループモードの追加設定
        loopedSlides: 3, // スライドが2枚の場合の設定
        observer: true, // DOMの変更を監視
        observeParents: true, // 親要素の変更も監視
      },
    });
  }
});
